module.exports = __webpack_public_path__ + "assets/images/popups/cancel_interstitial_ru.png";